export default __webpack_public_path__ + "static/media/tour-img.bd64e955.png";